import { TripOutput } from '@allocab/allocab-passenger-shared-types';
import { useState } from 'react';

import { UpdateTripModal } from './authenticated/UpdateTripModal';
import { useFetchCanUpdateTrip } from '../../../hooks/useFetchCanUpdateTrip';
import { t } from '../../../services/translation/translation';
import { SecondaryButton } from '../../button/SecondaryButton';

type Props = { trip: TripOutput };

export const UpdateTripButton = ({ trip }: Props) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { data, isLoading } = useFetchCanUpdateTrip(trip.key);

  return (
    <>
      {(data?.canUpdateDepartureAt === false &&
        data?.canUpdateEndAddress === false &&
        data?.canUpdateStartAddress === false) ||
      isLoading ? null : (
        <>
          <SecondaryButton className="w-full mt-2" onClick={() => setIsModalVisible(true)}>
            {t('common.update')}
          </SecondaryButton>
          {isModalVisible ? (
            <UpdateTripModal trip={trip} data={data} isLoading={isLoading} onClose={() => setIsModalVisible(false)} />
          ) : null}
        </>
      )}
    </>
  );
};
